import { render, staticRenderFns } from "./DemographicForm.vue?vue&type=template&id=36e19563&"
import script from "./DemographicForm.vue?vue&type=script&lang=js&"
export * from "./DemographicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports